/* Copyright (c) 2017 Backpack Health LLC */


export const types = {
  SHARE_PDF: 'app/shareCards/SHARE_PDF',
};

const initialState = {};

export default function reducer(state = initialState, action = {}) {
  switch (action.type) {
    default:
      return state;
  }
}

function sharePdf(cardData, languageCode, includeUrlOnPdf) {
  return {
    type: types.SHARE_PDF,
    payload: {
      languageCode,
      includeUrlOnPdf,
      cardData,
    },
  };
}

export const selectors = {

};

export const actions = {
  sharePdf,
};
